import { AccessObjectSource } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';

export type AccessObjectSourceTagProps = {
    accessObjectSource: AccessObjectSource;
};

export const accessObjectSourceLabels: Record<AccessObjectSource, string> = {
	[ AccessObjectSource.Custom ]: COPY_SPECIFIC.CUSTOM,
	[ AccessObjectSource.Package ]: COPY_SPECIFIC.PACKAGE,
	[ AccessObjectSource.Standard ]: COPY_SPECIFIC.STANDARD
};

const accessObjectSourceColors: Record<AccessObjectSource, string> = {
	[ AccessObjectSource.Custom ]: 'yellow',
	[ AccessObjectSource.Package ]: 'purple',
	[ AccessObjectSource.Standard ]: 'blue'
};

export const AccessObjectSourceTag: React.FC<AccessObjectSourceTagProps> = ({ accessObjectSource }) =>
	<Tag color={ accessObjectSourceColors[ accessObjectSource ] }>
		{ accessObjectSourceLabels[ accessObjectSource ] }
	</Tag>;
